export default __webpack_public_path__ + "static/media/eduact-small-logo.c747a4c8.svg";